import { isMobile } from "react-device-detect";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowLeft from "../../assets/live_switch_left.svg";
import ArrowRight from "../../assets/live_switch_right.svg";

export const ViewType = {
    Image: 'Camera',
    Streaming: 'Streaming'
}

export default function StaticLiveSwitch({ type, onClick }) {
    
    const { t } = useTranslation()

    return (
        <Box
            className={isMobile ? "live-camera-switch full-opacity" : "live-camera-switch"}
            onClick={onClick}
            sx={{
                height: isMobile ? 78 : 110,
                width: isMobile ? 78 : 110,
                backgroundSize: 'cover',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundImage: `url(${type === ViewType.Image ? ArrowLeft : ArrowRight})`,
                left: type === ViewType.Image && 5,
                right: type !== ViewType.Image && 5
            }}
        >
            <Box 
                component="span" 
                sx={{
                    color: 'white',
                    fontSize: isMobile ? '0.8rem' : '1rem',
                    paddingBottom: 0.25,
                    paddingLeft: type === ViewType.Image && 4,
                    paddingRight: type !== ViewType.Image && 2.5
                }}
            >
                {type === ViewType.Image ? t("image.static") : t("image.stream")}
            </Box>
        </Box>
    )
}